import { render } from "./PlaceSearch.vue?vue&type=template&id=31efe146"
import script from "./PlaceSearch.vue?vue&type=script&lang=js"
export * from "./PlaceSearch.vue?vue&type=script&lang=js"

import "./PlaceSearch.vue?vue&type=style&index=0&id=31efe146&lang=scss"
script.render = render

export default script